type CHAutocompleteResponse {
  entries: [CHAutocompleteEntry]!
}

type CHAddress {
  city: String
  line1: String
  line2: String
  postCode: String
  country: String
}

type CHAutocompleteEntry {
  companyNumber: String!
  name: String!
}

type CHCompany {
  address: CHAddress
  companyNumber: String
  directors: [CHOfficer]
  name: String!
  status: String
  telephone: String
  sicCode: ClientOrganisationSIC
  nonNaturalOrganisationType: ClientOrganisationType
}

type CHOfficer {
  address: CHAddress
  citizenship: String
  dateOfBirth: String
  firstNames: String
  lastName: String
  role: String
}

type NewClientAddress {
  address: LutherAddress
  is_current_correspondence: Boolean
}

type NewClientData {
  is_natural_person: Boolean
  client_type: [ClientType]
  first_name: String
  middle_name: String
  last_name: String
  nationalities: [String]
  date_of_birth: String
  addresses: [NewClientAddress]
}

type DirectorsFromCHResult {
  existingClients: [ClientVersion]
  newClients: [NewClientData]
}

input CHCompanyInput {
  address: CHAddressInput
  companyNumber: String
  directors: [CHOfficerInput]
  name: String!
  status: String
  telephone: String
  sicCode: ClientOrganisationSIC
  nonNaturalOrganisationType: ClientOrganisationType
}

input CHAddressInput {
  city: String
  line1: String
  line2: String
  postCode: String
  country: String
}

input CHOfficerInput {
  address: CHAddressInput
  citizenship: String
  dateOfBirth: String
  firstNames: String
  lastName: String
  role: String
}
